import { useRef } from "react";
import { SHORTCUT_KEYS, type ShortcutName } from "../../hooks/useShortcuts";
import { useUiStore } from "../../store/uiStore";
import { Button } from "../Button";
import { ModalShell } from "../ModalShell";

const ORDER: readonly ShortcutName[] = ["add", "edit", "save", "cancel", "next", "previous"];

export function ShortcutHelp() {
  const isOpen = useUiStore((state) => state.isShortcutHelpOpen);
  const setOpen = useUiStore((state) => state.setShortcutHelpOpen);
  const closeRef = useRef<HTMLButtonElement>(null);

  if (!isOpen) return null;

  return (
    <ModalShell
      title="Keyboard shortcuts"
      description="Shortcuts apply on screens that offer the matching action."
      onClose={() => setOpen(false)}
      initialFocusRef={closeRef}
      size="sm"
      footer={
        <Button ref={closeRef} variant="secondary" onClick={() => setOpen(false)}>
          Close
        </Button>
      }
    >
      <dl className="grid grid-cols-[auto_1fr] gap-x-6 gap-y-2 text-sm">
        {ORDER.map((name) => (
          <div key={name} className="contents">
            <dt>
              <kbd className="rounded border border-gray-300 bg-gray-50 px-2 py-0.5 font-mono text-xs text-gray-700">{SHORTCUT_KEYS[name].label}</kbd>
            </dt>
            <dd className="text-gray-700">{SHORTCUT_KEYS[name].description}</dd>
          </div>
        ))}
      </dl>
    </ModalShell>
  );
}
